module.exports = __webpack_public_path__ + "img/search.500d3728.svg";